<template>
  <dialog-email
    ref="dialog"
    :isLoading="isLoading"
    :contentKey="contentKey"
    :contentMap="contentMap"
    :data="data"
    @on-submit-email="handlerSubmit"
  ></dialog-email>
</template>

<script>

import { ServiceRFQ3s } from '@/services/RFQ3s'
import { ServiceEmailMessages } from '@/services/email-messages'

export default {
  name: 'DialogSendEmailExchangeAgreement',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  props: {
    id: { required: true }
  },
  data () {
    return {
      isLoading: false,
      logoType: 0,
      data: {},
      contentMap: {}
    }
  },
  computed: {
    contentKey () {
      return 'exchange-agreement-email'
    }
  },
  methods: {
    show ({ logoType }) {
      this.logoType = logoType
      this.$refs.dialog.show()
      this.loadMapData()
        .then(() => {
          this.createEmailData()
        })
    },
    hide () {
      this.logoType = 0
      this.$refs.dialog.hide()
    },
    createEmailData () {
      const { po, email } = this.contentMap
      const subject = `${this.L10n('exchange-agreement-for-po')} : ${po}`
      let emailToList = []
      email && emailToList.push(email)
      this.data = {
        subject,
        emailToList
      }
    },
    async loadMapData () {
      this.isLoading = true
      try {
        const { data } = await ServiceRFQ3s.getDynamic(this.id, {
          select: [
            'id', 'rfq.customerContact.name as customerContactName',
            'rfq.customerContact.email as email', 'rfq.po as po'
          ].join(',')
        })
        this.contentMap = data
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    async handlerSubmit (emailData) {
      this.isLoading = true
      const { po } = this.contentMap

      try {
        await ServiceEmailMessages.sendExchangeAgreement({
          id: this.id,
          logoKey: this.logoType,
          po,
          translate: this.L10n,
          ...emailData
        })
        this.$emit('onSent', emailData)
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
        this.hide()
      }
    }
  }
}
</script>
